import { RouteConfig } from 'vue-router'
import Layout from '@/layout/index.vue'

const appRoutes: RouteConfig = {
  path: '/flutter',
  component: Layout,
  redirect: 'noRedirect', // '/vendors/list',
  name: 'App',
  meta: {
    title: 'app',
    icon: 'people',
    roles: ['Admin']
  },

  children: [
    {
      path: 'fields/new',
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/flutter-app/AppField.vue'),
      name: 'NewField',
      meta: {
        title: 'appFieldNew',
        icon: 'edit',
        affix: false
      }
    },
    {
      path: 'fields/all',
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/flutter-app/FieldList.vue'),
      name: 'Fields',
      meta: {
        title: 'appFields',
        icon: 'list',
        affix: false
      }
    },
    {
      path: 'select-items/all',
      component: () => import(/* webpackChunkName: "dashboard" */ '@/views/flutter-app/SelectItemsList.vue'),
      name: 'SelectItems',
      meta: {
        title: 'selectItems',
        icon: 'list',
        affix: false
      }
    },
    {
      path: 'steps',
      component: () => import(/* webpackChunkName: "vendors-create" */ '@/views/flutter-app/AppStepsLayout.vue'),
      name: 'Steps',
      meta: {
        title: 'appSteps',
        icon: 'dashboard'
      }
    }
  ]
}

export default appRoutes
